<template>
  <the-dialog-box
    ref="dialogBox"
    :is-submit-btn="false"
    :full-screen="true"
  >
    <template slot="header">
      <span
        v-if="item"
        style="font-size: 30px; font-weight: 500; color: #000000;"
      >Job: {{ item.wo_number }} - {{ item.project }}; {{ item.project_floor }}</span>
      <v-col class="text-end">
        <span style="font-size: 30px; font-weight: 500; color: #000000;">Total Items: {{ items.length }}</span>
      </v-col>
    </template>
    <template slot="body">
      <v-row>
        <v-col>
          <v-card
            elevation="0"
            outlined
          >
            <v-data-table
              :headers="headers"
              :items="items"
              hide-default-footer
              :items-per-page="-1"
              :loading="loading"
              dense
            >
              <template #[`item.cut_height`]="{ item }">
                <span>
                  {{ item.cut_height ? item.cut_height : '-' }}
                </span>
              </template>
              <template #[`item.location`]="{ item }">
                <span>
                  {{ item.location ? item.location.name : '' }}
                </span>
              </template>
              <template #[`item.inventory_location`]="{ item }">
                <span>
                  {{ item.inventory_location ? item.inventory_location.name : '' }}
                </span>
              </template>
              <template #[`item.status`]="{ item }">
                <v-tooltip
                  bottom
                  color="black"
                >
                  <template #activator="{ on }">
                    <v-chip
                      v-if="item && item.status"
                      small
                      :color="item.status.color ? item.status.color : '#000000'"
                      text-color="white"
                      @mouseover="getHistory(item)"
                      v-on="on"
                    >
                      {{ item.status.name }}
                    </v-chip>
                  </template>

                  <div
                    style="width: 400px; flex-direction: column; gap: 12px;"
                    class="pt-3 d-flex"
                  >
                    <div
                      v-for="history in finishedGoodHistories"
                      :key="history.id"
                      class="d-flex align-center"
                    >
                      <div style="width: 50%">
                        <v-chip
                          v-if="history && history.status"
                          small
                          :color="history.status.color ? history.status.color : '#000000'"
                          text-color="white"
                        >
                          {{ history.status.name }}
                        </v-chip>
                      </div>
                      <span> At: {{ history.created_at }}</span>
                    </div>
                  </div>
                </v-tooltip>
              </template>
              <template #[`item.department`]="{ item }">
                <span>
                  {{ item.department ? item.department.name : '' }}
                </span>
              </template>
              <template #[`item.quarantine_remake_reason`]="{ item }">
                <span>
                  {{ item.quarantine_reason ? item.quarantine_reason.name : '' }} - {{ item.quarantine_sub_reason ? item.quarantine_sub_reason.name : '' }}; {{ item.quarantined_at ? item.quarantined_at : '' }}
                </span>
              </template>
              <template #[`item.note`]="{ item }">
                <div
                  v-if="hasNote(item)"
                  class="d-flex justify-center"
                >
                  <div
                    class="d-flex align-center"
                    style="max-width: 300px; min-width: 200px; gap: 12px;"
                  >
                    <v-btn
                      icon
                      small
                      class="mr-2 mt-n1"
                      @click="openNoteForm(item.id)"
                    >
                      <v-icon small>
                        mdi-eye
                      </v-icon>
                    </v-btn>

                    <div>
                      <div v-if="item.notes && item.notes.length">
                        <strong>Note:</strong> {{ item.notes[0].text }}
                      </div>

                      <div v-if="item.shipping_notes && item.shipping_notes.length">
                        <strong>Shipping:</strong> {{ item.shipping_notes[0].text }}
                      </div>
                    </div>
                  </div>
                </div>

                <v-btn
                  v-else
                  color="primary"
                  small
                  icon
                  @click="openNoteForm(item.id)"
                >
                  <v-icon small>
                    mdi-pencil
                  </v-icon>
                </v-btn>
              </template>
            </v-data-table>
          </v-card>
        </v-col>
      </v-row>
      <NoteForm
        ref="noteForm"
        @success="get(item, statusId)"
      >
        <template #actions="{ addNew, item }">
          <v-btn
            color="warning"
            outlined
            class="mr-2"
            @click="addShippingNote(item, addNew)"
          >
            <v-icon
              small
              class="mr-1"
            >
              fas fa-plus
            </v-icon>
            New Shipping Note
          </v-btn>

          <v-btn
            color="primary"
            outlined
            @click="addNote(item, addNew)"
          >
            <v-icon
              small
              class="mr-1"
            >
              fas fa-plus
            </v-icon>
            New Note
          </v-btn>
        </template>

        <template #notes-list="{ notesByType, edit, softDelete }">
          <v-row
            v-for="section in [
              { title: 'Notes', typeId: noteTypeIdFinishedGood },
              { title: 'Shipping Notes', typeId: noteTypeIdFinishedGoodShipping },
            ]"
            :key="section.typeId"
          >
            <v-col>
              <h3 class="mb-2">{{ section.title }}</h3>

              <v-card-text
                v-if="notesByType(section.typeId).length > 0"
                style="max-height: 300px; overflow-y: auto; border: 1px solid #d3d3d3; border-radius: 3px;"
              >
                <v-list two-line class="pt-0 pb-0">
                  <template v-for="(note, index) in notesByType(section.typeId)">
                    <v-list-item :key="note.id">
                      <v-list-item-content>
                        {{ note.text }}

                        <v-list-item-subtitle style="padding-top: 10px;">
                          {{ note.created_at }}
                        </v-list-item-subtitle>

                        <v-list-item-subtitle v-if="note.created_by_name">
                          {{ note.created_by_name }}
                        </v-list-item-subtitle>

                        <v-list-item-subtitle
                          v-if="canModifyNote(note)"
                          class="text-end"
                        >
                          <v-btn
                            color="primary"
                            class="mr-2"
                            outlined
                            small
                            @click="edit(note)"
                          >
                            <v-icon small class="mr-1">
                              mdi-pencil
                            </v-icon>
                          </v-btn>

                          <v-btn
                            color="error"
                            outlined
                            small
                            @click="softDelete(note)"
                          >
                            <v-icon small class="mr-1">
                              fas fa-trash
                            </v-icon>
                          </v-btn>
                        </v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>

                    <v-divider
                      v-if="index < notesByType(section.typeId).length - 1"
                      :key="`divider-${note.id}`"
                    />
                  </template>
                </v-list>
              </v-card-text>

              <div
                v-else
                class="grey--text"
              >
                No {{ section.title.toLowerCase() }}.
              </div>
            </v-col>
          </v-row>
        </template>
      </NoteForm>
    </template>
  </the-dialog-box>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import NoteForm from '@/components/forms/notes/NoteForm.vue';

export default {
  components: {
    NoteForm,
  },
  props: {

  },
  data: () => ({
    items: [],
    loading: false,
    item: null,
    noteTypeIdFinishedGood: 3,
    noteTypeIdFinishedGoodShipping: 15,
    finishedGoodStatusIdReturned: 12,
    finishedGoodStatusIdQuarantined: 13,
    statusIdFinishedGoods: 8,
    statusId: null,
    finishedGoodHistories: [],
    loadingHistory: false,
  }),
  computed: {
    ...mapState({

    }),
    ...mapGetters([

    ]),
    headers() {
      const returnHeaders = [];
      returnHeaders.push({ text: 'Serial#', value: 'index' });
      returnHeaders.push({ text: 'Tag Id', value: 'tag_id' });
      returnHeaders.push({ text: 'Tag Number', value: 'tag_number' });
      returnHeaders.push({ text: 'Work Order', value: 'work_order' });
      returnHeaders.push({ text: 'Reference', value: 'floor_number' });
      returnHeaders.push({ text: 'Cut Width', value: 'cut_width' });
      returnHeaders.push({ text: 'Cut Height', value: 'cut_height' });
      returnHeaders.push({ text: 'Sqft', value: 'sqft' });

      if (this.statusId > this.statusIdFinishedGoods) {
        returnHeaders.push({ text: 'Location', value: 'location' });
        returnHeaders.push({ text: 'Shelf', value: 'inventory_location' });
      }

      if (this.statusId === this.finishedGoodStatusIdReturned) {
        returnHeaders.push({
          text: 'Return Reason', value: 'return_reason',
        });
      }

      if (this.statusId === this.finishedGoodStatusIdQuarantined) {
        returnHeaders.push({
          text: 'Department', value: 'department',
        });
      }
      if (this.statusId === this.finishedGoodStatusIdQuarantined) {
        returnHeaders.push({
          text: 'Quarantine Reasons', value: 'quarantine_remake_reason',
        });
      }

      returnHeaders.push({ text: 'Status', value: 'status', align: 'center' });
      returnHeaders.push({ text: 'Note', value: 'note', align: 'center' });

      return returnHeaders;
    },
  },
  watch: {

  },
  created() {
  },
  methods: {

    canModifyNote(note) {
      const user = this.$store.getters.user;

      return note && user && (
        user.roles?.some((role) => role.name === 'Admin') || Number(note.created_by) === Number(user.id)
      );
    },

    async get(item, statusId) {
      this.loading = true;
      this.items = [];
      const submitModel = {
        filters: {
          production_schedule_id: item.id,
          status_id: statusId,
        },
      };
      const res = await this.$api.finishedGood.read(submitModel);
      this.loading = false;
      if (!res) return;
      this.items = res;
    },

    async getHistory(item) {
      if (this.loadingHistory) return;
      this.loadingHistory = true;
      const submitModel = {
        filters: {
          finished_good_id: item.id,
        },
      };

      const res = await this.$api.finishedGoodHistory.read(submitModel);

      this.loadingHistory = false;
      if (!res || !res.data || res.data.length === 0) {
        this.finishedGoodHistories = [];
        return;
      }

      this.finishedGoodHistories = res.data;
    },

    open(item, statusId) {
      this.item = item;
      this.statusId = statusId;
      this.get(item, statusId);
      this.$refs.dialogBox.open();
    },

    openNoteForm(itemId) {
      this.$refs.noteForm.open(
        itemId,
        this.noteTypeIdFinishedGood,
        [
          this.noteTypeIdFinishedGood,
          this.noteTypeIdFinishedGoodShipping,
        ],
      );
    },

    addNote(noteItem, addNew) {
      noteItem.type_id = this.noteTypeIdFinishedGood;
      this.$refs.noteForm.label = 'Note';
      addNew();
    },

    addShippingNote(noteItem, addNew) {
      noteItem.type_id = this.noteTypeIdFinishedGoodShipping;
      this.$refs.noteForm.label = 'Shipping Note';
      addNew();
    },

    noteListTitle(typeId) {
      if (typeId === this.noteTypeIdFinishedGoodShipping) return 'Shipping Notes';
      return 'Notes';
    },

    hasNote(item) {
      return (item.notes && item.notes.length > 0)
        || (item.shipping_notes && item.shipping_notes.length > 0);
    },

    notePreview(item) {
      const note = item.notes && item.notes.length > 0
        ? item.notes[0].text
        : null;

      const shippingNote = item.shipping_notes && item.shipping_notes.length > 0
        ? item.shipping_notes[0].text
        : null;

      const previews = [];

      if (note) previews.push(`Note: ${note}`);
      if (shippingNote) previews.push(`Shipping: ${shippingNote}`);

      return previews.join(' | ');
    },
  },
};
</script>
